import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// JS Files

// Others File



const ContactusCard = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="border border-myorange-400 rounded-lg  flex flex-col items-center justify-center p-4">
        <img src={props.icon} />
        <p className="font-bold text-myorange-500 mt-4">{props.header}</p>
        <p className="text-sm leading-8 text-mygray-700 m-2 text-center">
         {props.text}
        </p>
      </div>
    </>
  );
};
export default ContactusCard;
